import { OperationResult } from './operation_result';

interface OperationHash {
  [name: string]: OperationResult;
}

export class ServerResult {

  private resultsArray: OperationResult[] = [];

  private isError: boolean = false;
  private errorLevel: number = 0;

  public static fromResponse(response: any): ServerResult {
    const operationResults: OperationHash = {};

    for (const key in response.result) {
      if(['atomic_status'].indexOf(key) >= 0) continue;
      operationResults[key] = OperationResult.fromResponse(response.result[key]);
    }

    return new ServerResult(operationResults);
  }

  constructor(private resultByName: OperationHash) {
    for (const key in resultByName) {
      const operationResult = resultByName[key];

      this.resultsArray.push(operationResult);

      //console.log(`QUERY: ${key} / `, operationResult.hasError() ? ' with errors ' : '', operationResult);

      if (operationResult.hasError()) {
        this.isError = this.isError || operationResult.hasError();

        const errorLevel = operationResult.getErrorLevel();
        if(this.errorLevel < errorLevel) {
          this.errorLevel = errorLevel;
        }
      }

    }
  }

  getOperation(name: string): OperationResult {
    return this.resultByName[name];
  }

  getOperationNames(): string[] {
    return Object.keys(this.resultByName);
  }

  hasError(): boolean {
    return this.isError;
  }

  getContent(): any {
    return this.resultsArray.map(result => {
      return result.getContent();
    });
  }

  getErrorLevel() {
    return this.errorLevel;
  }

}
